"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.divider = void 0;
const tv_1 = require("../utils/tv");
const orientations = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
exports.divider = (0, tv_1.tv)({
  base: '',
  variants: {
    orientation: {
      horizontal: 'border-t w-full',
      vertical: 'border-l h-full'
    },
    color: {
      light: 'border-light',
      dark: 'border-dark',
      inverse: 'border-inverse'
    },
    bold: {
      true: '',
      // See compoundVariants config
      false: ''
    },
    rounded: {
      true: 'rounded-2xs',
      false: ''
    }
  },
  compoundVariants: [{
    orientation: orientations.horizontal,
    bold: true,
    class: 'border-t-md'
  }, {
    orientation: orientations.horizontal,
    bold: false,
    class: 'border-t-sm'
  }, {
    orientation: orientations.vertical,
    bold: true,
    class: 'border-l-md'
  }, {
    orientation: orientations.vertical,
    bold: false,
    class: 'border-l-sm'
  }],
  defaultVariants: {
    orientation: 'horizontal',
    color: 'light',
    bold: false,
    rounded: false
  }
});
